module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Dislike-2e8eda2e2af47c10eb30edefcdfcc5d5.svg";